import Header from "../components/Header";
import Footer from "../components/Footer"

export default function Career() {
    return (
        <div>
            <Header />
            <section className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-sky-100 pt-36 pb-24">
                <div className="w-full max-w-6xl grid grid-cols-1 md:grid-cols-2 gap-16 items-center px-4">

                    {/* LEFT SIDE — JOB LIST */}
                    <div>
                        <div className="inline-flex items-center gap-2 px-4 py-1 mb-6 text-xs font-semibold tracking-wide text-blue-700 uppercase bg-blue-100 rounded-full">
                            Join Our Team
                        </div>
                        <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-6">
                            Open <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">Positions</span>
                        </h2>
                        <p className="text-slate-500 mb-8">
                            Be part of something great. Join Adeya IMS and help businesses transform their inventory management.
                        </p>

                        <div className="space-y-6">

                            {/* Job 1 */}
                            <div className="group p-5 border border-slate-200 rounded-xl hover:border-blue-300 hover:shadow-md transition-all duration-300 cursor-pointer">
                                <div className="flex justify-between items-start">
                                    <div>
                                        <h4 className="font-bold text-lg text-slate-800 group-hover:text-blue-600 transition">AI Engineer</h4>
                                        <p className="text-slate-500 text-sm mt-1">Full-time • Remote • India</p>
                                    </div>
                                    <span className="text-blue-600 opacity-0 group-hover:opacity-100 transition">→</span>
                                </div>
                                <p className="text-slate-500 text-sm mt-3">
                                    Build intelligent AI agents for inventory optimization and demand forecasting.
                                </p>
                                <div className="flex flex-wrap gap-2 mt-3">
                                    <span className="px-2 py-1 bg-blue-50 text-blue-600 text-xs rounded-md">Python</span>
                                    <span className="px-2 py-1 bg-blue-50 text-blue-600 text-xs rounded-md">TensorFlow</span>
                                    <span className="px-2 py-1 bg-blue-50 text-blue-600 text-xs rounded-md">LLM</span>
                                </div>
                            </div>

                            {/* Job 2 */}
                            <div className="group p-5 border border-slate-200 rounded-xl hover:border-blue-300 hover:shadow-md transition-all duration-300 cursor-pointer">
                                <div className="flex justify-between items-start">
                                    <div>
                                        <h4 className="font-bold text-lg text-slate-800 group-hover:text-blue-600 transition">UI/UX Designer</h4>
                                        <p className="text-slate-500 text-sm mt-1">Full-time • Remote • India</p>
                                    </div>
                                    <span className="text-blue-600 opacity-0 group-hover:opacity-100 transition">→</span>
                                </div>
                                <p className="text-slate-500 text-sm mt-3">
                                    Design beautiful, intuitive interfaces for our inventory management platform.
                                </p>
                                <div className="flex flex-wrap gap-2 mt-3">
                                    <span className="px-2 py-1 bg-blue-50 text-blue-600 text-xs rounded-md">Figma</span>
                                    <span className="px-2 py-1 bg-blue-50 text-blue-600 text-xs rounded-md">Adobe XD</span>
                                    <span className="px-2 py-1 bg-blue-50 text-blue-600 text-xs rounded-md">User Research</span>
                                </div>
                            </div>

                            {/* Job 3 */}
                            <div className="group p-5 border border-slate-200 rounded-xl hover:border-blue-300 hover:shadow-md transition-all duration-300 cursor-pointer">
                                <div className="flex justify-between items-start">
                                    <div>
                                        <h4 className="font-bold text-lg text-slate-800 group-hover:text-blue-600 transition">Full Stack Developer</h4>
                                        <p className="text-slate-500 text-sm mt-1">Full-time • Remote • India</p>
                                    </div>
                                    <span className="text-blue-600 opacity-0 group-hover:opacity-100 transition">→</span>
                                </div>
                                <p className="text-slate-500 text-sm mt-3">
                                    Build scalable features using MERN stack, Docker, and cloud technologies.
                                </p>
                                <div className="flex flex-wrap gap-2 mt-3">
                                    <span className="px-2 py-1 bg-blue-50 text-blue-600 text-xs rounded-md">React</span>
                                    <span className="px-2 py-1 bg-blue-50 text-blue-600 text-xs rounded-md">Node.js</span>
                                    <span className="px-2 py-1 bg-blue-50 text-blue-600 text-xs rounded-md">Docker</span>
                                </div>
                            </div>

                        </div>
                    </div>

                    {/* RIGHT SIDE — FORM CARD */}
                    <div className="bg-white rounded-2xl shadow-xl border border-blue-500 p-6 md:p-8">
                        <h3 className="text-2xl font-bold text-slate-800 mb-2">Apply Now</h3>
                        <p className="text-slate-500 text-sm mb-6">Fill the form and we'll get back to you.</p>

                        <form>
                            <div className="grid grid-cols-2 gap-4 mb-4">
                                <div>
                                    <label className="text-sm font-medium text-slate-700">First Name <span className="text-red-500">*</span></label>
                                    <input 
                                        type="text" 
                                        className="w-full mt-1 px-4 py-2 rounded-lg border border-slate-200 focus:border-blue-400 focus:ring-2 focus:ring-blue-100 outline-none transition bg-slate-50"
                                        placeholder="John"
                                    />
                                </div>
                                <div>
                                    <label className="text-sm font-medium text-slate-700">Last Name <span className="text-red-500">*</span></label>
                                    <input 
                                        type="text" 
                                        className="w-full mt-1 px-4 py-2 rounded-lg border border-slate-200 focus:border-blue-400 focus:ring-2 focus:ring-blue-100 outline-none transition bg-slate-50"
                                        placeholder="Doe"
                                    />
                                </div>
                            </div>

                            <div className="mb-4">
                                <label className="text-sm font-medium text-slate-700">Email Address <span className="text-red-500">*</span></label>
                                <input 
                                    type="email" 
                                    className="w-full mt-1 px-4 py-2 rounded-lg border border-slate-200 focus:border-blue-400 focus:ring-2 focus:ring-blue-100 outline-none transition bg-slate-50"
                                    placeholder="john@example.com"
                                />
                            </div>

                            <div className="mb-4">
                                <label className="text-sm font-medium text-slate-700">Phone Number <span className="text-red-500">*</span></label>
                                <input 
                                    type="tel" 
                                    className="w-full mt-1 px-4 py-2 rounded-lg border border-slate-200 focus:border-blue-400 focus:ring-2 focus:ring-blue-100 outline-none transition bg-slate-50"
                                    placeholder="+91 00000 00000"
                                />
                            </div>

                            <div className="mb-4">
                                <label className="text-sm font-medium text-slate-700">Position Applying For <span className="text-red-500">*</span></label>
                                <select className="w-full mt-1 px-4 py-2 rounded-lg border border-slate-200 focus:border-blue-400 focus:ring-2 focus:ring-blue-100 outline-none transition bg-slate-50">
                                    <option value="">Select position</option>
                                    <option>AI Engineer</option>
                                    <option>UI/UX Designer</option>
                                    <option>Full Stack Developer</option>
                                </select>
                            </div>

                            <div className="mb-4">
                                <label className="text-sm font-medium text-slate-700">Cover Letter / Introduce Yourself <span className="text-red-500">*</span></label>
                                <textarea
                                    rows="4"
                                    className="w-full mt-1 px-4 py-2 rounded-lg border border-slate-200 focus:border-blue-400 focus:ring-2 focus:ring-blue-100 outline-none transition resize-none bg-slate-50"
                                    placeholder="Tell us why you'd be a great fit..."
                                ></textarea>
                            </div>

                            <div className="mb-6">
                                <label className="text-sm font-medium text-slate-700">Upload Resume <span className="text-red-500">*</span></label>
                                <div className="mt-1 border-2 border-dashed border-slate-200 rounded-lg p-4 text-center hover:border-blue-400 transition cursor-pointer bg-slate-50">
                                    <input type="file" className="hidden" id="resume-upload" />
                                    <label htmlFor="resume-upload" className="cursor-pointer">
                                        <i className="fas fa-cloud-upload-alt text-blue-500 text-2xl mb-2 block"></i>
                                        <span className="text-slate-500 text-sm">Click to upload or drag and drop</span>
                                        <p className="text-slate-400 text-xs mt-1">PDF, DOC up to 5MB</p>
                                    </label>
                                </div>
                            </div>

                            <button className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold py-3 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5">
                                Submit Application
                            </button>
                        </form>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
}